import React, { FunctionComponent } from 'react';

import { getApiData } from 'scenes/common/helpers/apiData';
import { RecentInsurerStep as CommonRecentInsurerStep } from 'scenes/common/components/Steps';

import {
  getCoverType,
  getRecentInsurer,
  isBuildingAndContentsCoverType,
} from 'scenes/landlord/selectors';
import { LandlordFullPageProps } from 'scenes/landlord/types';
import { CoverType, InsuredItem } from 'scenes/common/types';

const question: {
  [key in CoverType]: string;
} = {
  [CoverType.BuildingAndContents]: `Who is the current or was the most recent building and contents insurer for the ${InsuredItem.Property}?`,
  [CoverType.Building]: `Who is the current or was the most recent building insurer for the ${InsuredItem.Property}?`,
  [CoverType.Contents]: `Who is the current or was the most recent contents insurer for your ${InsuredItem.Property}?`,
  [CoverType.Unspecified]: `Who is the current or was the most recent building and contents insurer for the ${InsuredItem.Property}?`,
};

export const HELP_TEXT =
  'If you have different insurers for building and contents, select your building insurance provider.';

const RecentInsurerStep: FunctionComponent<LandlordFullPageProps> = ({
  referenceData,
  funnelState,
  onNext,
}) => {
  const { recentInsurerOptions } = getApiData(referenceData);

  return (
    <CommonRecentInsurerStep
      defaultStateValue={getRecentInsurer(funnelState)}
      question={question[getCoverType(funnelState)]}
      onNext={onNext}
      recentInsurerOptions={recentInsurerOptions}
      helpText={isBuildingAndContentsCoverType(funnelState) ? HELP_TEXT : ''}
    />
  );
};

export default RecentInsurerStep;
